import React from 'react';
import RadioButton from '../../Inputs/Radiobutton';
import clsx from 'clsx';

interface CheckoutRadioProps {
  className?: string;
  title?: string;
  description?: string;
  cost?: string;
  logo?: JSX.Element | string;
  stateKey?: string;
  id?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  checked?: boolean;
}

const CheckoutRadio = ({
  className,
  title,
  description,
  cost,
  logo,
  stateKey,
  id,
  onChange,
  checked = false,
}: CheckoutRadioProps) => {
  return (
    <label
      htmlFor={`${stateKey}-${id}`}
      className={clsx(
        className,
        'flex',
        'flex-1',
        'cursor-pointer',
        'py-3',
        'px-4',
        'border',
        'border-solid',
        checked ? 'border-black' : 'border-gray-200',
        'rounded',
        'items-center',
        'gap-4'
      )}
    >
      <RadioButton
        checked={checked}
        name={stateKey}
        type="radio"
        id={`${stateKey}-${id}`}
        onChange={onChange}
      />
      <div className={clsx('flex', 'flex-1', 'flex-col', 'gap-2')}>
        <span className="text-xl font-bold">{title}</span>
        {description && <span className="text-lg">{description}</span>}
      </div>
      <div
        className={clsx('flex', 'items-center', 'justify-center', 'gap-2')}
      >
        {logo && logo}
        <span className="text-lg">{cost}</span>
      </div>
    </label>
  );
};

export default CheckoutRadio;
